import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function SplitButton({ items }) {
  return (
    <div className="inline-flex rounded-md shadow-sm">
      <button
        type="button"
        className="relative inline-flex items-center rounded-l-md bg-gray-50 dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-200 ring-1 ring-inset ring-gray-100 dark:ring-gray-700 hover:bg-gray-100 dark:hover:bg-white/[0.06] focus:z-10 leading-none"
        onClick={items[0].onClick}
      >
        {items[0].name}
      </button>
      <Menu as="div" className="relative -ml-px block">
        <Menu.Button className="relative inline-flex items-center rounded-r-md bg-gray-50 dark:bg-gray-800 px-2 py-2 text-gray-400 dark:text-gray-500 ring-1 ring-inset ring-gray-100 dark:ring-gray-700 hover:bg-gray-100 dark:hover:bg-white/[0.06] focus:z-10 leading-none">
          <span className="sr-only">Open options</span>
          <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-50 -mr-1 mt-2 w-56 origin-top-right rounded-md bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 dark:ring-gray-700 focus:outline-none">
            <div className="py-1">
              {items && items.length > 0 ? (
                items.map((item) => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <a
                        className={classNames(
                          active ? "bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white" : "text-gray-700 dark:text-gray-300",
                          "block px-4 py-2 text-sm hover:cursor-pointer"
                        )}
                        onClick={(event) => {
                          item.onClick && item.onClick(event);
                        }}
                      >
                        {item.name}
                      </a>
                    )}
                  </Menu.Item>
                ))
              ) : (
                <p className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300">
                  No items found
                </p>
              )}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}

export { SplitButton };
